module.exports = __webpack_public_path__ + "static/media/catherine.c490c239.jpeg";